// Layout
const dashboardLayout = () => import('@/layouts/DriverLayout/DashboardLayout/dashboardLayout.vue')

const trips = () => import('./views/index')

// start Routes
export default [
  {
    path: '/driver/trips',
    component: dashboardLayout,
    children: [{
      path: '',
      name: 'driverTrips',
      meta: {
        name: 'driverTrips',
        parentName: 'trips',
        userType: '',
        permission: '',
        role: 'transportation.driver'
      },
      component: trips
    }
    ]
  }
]
